module.exports = __webpack_public_path__ + "static/media/the-crew.1eab142e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/the-crew.jpg
// module id = 613
// module chunks = 0